const AdviceRankBckColor = {
    1: '#FC606F',
    2: '#B1B2B7',
    3: '#AD7347',
    'default': 'rgba(52,61,71,1)',
};

export {
    AdviceRankBckColor,
};